import assert from "assert";

assert(process.env.REACT_APP_UNSPLASH_ACCESS_KEY);
export const UnsplashAccessKey = process.env.REACT_APP_UNSPLASH_ACCESS_KEY;
